<template>
<footer class="flex flex-col lg:flex-row lg:items-center lg:justify-center">
    <p @click.prevent="resetQuiz" class="select-none">Parteneri</p>
    <div class="logos grid grid-cols-3 lg:flex items-center">
        <a href="https://politiaromana.ro" target="_blank"><img class="mx-auto" src="/img/logos/politiaromana.svg" alt="Poliția Română"/></a>
        <a href="https://dnsc.ro" target="_blank"><img class="mx-auto" src="/img/logos/dnsc.png" alt="Directoratul Național de Securitate Cibernetică"/></a>
        <a href="https://arb.ro" target="_blank"><img class="mx-auto" src="/img/logos/arb.png" alt="Asociaţia Română a Băncilor"/></a>
        <a href="https://microsoft.ro" target="_blank"><img class="mx-auto" src="/img/logos/microsoft.png" alt="Microsoft România"/></a>
        <a href="https://attacksimulator.com" target="_blank"><img class="mx-auto" src="/img/logos/attacksimulator.png" alt="ATTACK Simulator"/></a>
        <a href="https://sigurantaonline.ro" target="_blank"><img class="mx-auto" src="/img/logos/sigurantaonline.png" alt="Siguranța Online"/></a>
    </div>
</footer>
</template>

<script>
export default {
	name: "Footer",
	methods: {
		resetQuiz() {
			window.emitter.emit("forceReset");
		}
	}
};
</script>

<style scoped lang="scss">
footer {
    --min-height: 130px;
    --border: 2px solid black;
    --logos-spacing: 20px;
    --spacing: 20px;
    --text-size: 12px;
    --logo-size: 30px;

    @media (min-width: 1024px) {
        --min-height: 130px;
        --border: 4px solid black;
        --logos-spacing: 40px;
        --spacing: 80px;
        --text-size: 16px;
        --logo-size: 40px;
    }

    min-height: var(--min-height);
    border-top: var(--border);
    gap: var(--spacing);
    padding: var(--spacing);

    p {
        font-weight: 500;
        font-size: var(--text-size);
    }

    .logos {
        gap: var(--logos-spacing);
        img {
            height: var(--logo-size);
            max-width: inherit;
        }

        a:nth-child(1) img {
            height: calc(5px + var(--logo-size));
        }

        a:nth-child(2) img {
            height: calc(10px + var(--logo-size));
        }

        a:nth-child(3) img {
            height: calc(5px + var(--logo-size));
        }

        a:nth-child(4) img {
            height: calc(-10px + var(--logo-size));
        }
    }
}
</style>
